import styled from 'styled-components'

const CheckboxWithPreviewControls = styled('div')`
  float: right;
`

export default CheckboxWithPreviewControls
